import React from 'react'

export default function TooltipGraficoPizzaSemComunicar({
  active,
  payload,
  arrDados,
  totalSimcards,
  tooltipSimcardsSemComunicar
}) {
  let percentual = null
  if (totalSimcards === 0) {
    percentual = 100
  } else if (active && payload !== null && payload.length > 0) {
    percentual = `${parseFloat((payload[0].payload.value / tooltipSimcardsSemComunicar) * 100).toFixed(2)}`
  } else if (arrDados?.length === 0) {
    percentual = 0
  }

  if (percentual === null) return null

  return (
    <div className="container-tooltip-grafico-pizza">
      <p className="label-tooltip-grafico-pizza">{percentual}%</p>
    </div>
  )
}
